<!--
Author: TangChen
Date: 2018-11-09
Desc: 用户持有银行卡信息组件，由index.js 配置引入
-->
<template>
    <div class="bizcomp-hold-bank">
        <div class="bar-contain">
            <div class="bar"></div>
            <div class="bar-text">我的银行卡</div>
        </div>
        <div class="hold-bank-list-contain">
            <div v-for="(bank, index) in bankInfo" :key="index" class="hold-bank-list">
                <div
                    :class="
                        'bank-card ' +
                        (index % 3 < 2 ? 'margin-right-25 ' : '') +
                        (index > 2 ? 'margin-top-16' : '')
                    "
                >
                    <div class="bank-info">
                        <div class="bank-img">
                            <img :src="$util.getImg(bank.bankcode)" alt="" />
                        </div>
                        <div class="bank-name">
                            <span class="t">{{ $cache.getDict("110080", bank.bankcode) }}</span>
                            <span class="c">
                                <span v-if="bank.paycenterid != '0001'">
                                    {{
                                        $cache.getDict("110079", bank.paycenterid) +
                                        (bank.hkcardflag === "1" ? "(汇款支付)" : "(在线支付)")
                                    }}
                                </span>
                                <span v-else>
                                    {{ $cache.getDict("110079", bank.paycenterid) }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <p class="bank-num">
                        {{ $util.getNewCard(bank.depositcard) }}
                    </p>
                    <div v-if="$util.getConfig().hideFunc" class="bank-action">
                        <!-- <el-button
                            v-if="
                                bank.paycenterid != '1000' &&
                                bank.authenticateflag === '0' &&
                                (bank.identifytype == '1' ||
                                    bank.identifytype == '2')
                            "
                            size="mini"
                            v-on:click.once="
                                $router.push({
                                    name: 'activebank',
                                    query: bank,
                                })
                            "
                        >
                            激活
                        </el-button> -->
                        <button
                            v-if="bank.authenticateflag === '2'"
                            class="bank-btn"
                            v-on:click.once="
                                $router.push({
                                    name: 'modifybank',
                                    query: bank
                                })
                            "
                        >
                            修改
                        </button>
                        <!-- <button
                            class="bank-btn"
                            v-on:click.once="
                                $router.push({
                                    name: 'changecard',
                                    query: bank
                                })
                            "
                        >
                            换卡
                        </button> -->
                        <button
                            class="bank-btn"
                            v-on:click="deleteBank(bank.bankcardid, bank.paycenterid)"
                        >
                            解绑
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <div
                    v-if="!$util.getConfig().hideFunc && bankInfo.length === 0"
                    class="bank-card-add"
                >
                    <div class="img-text-contain">
                        <img class="no-card" src="@/assets/img/no-card.png" alt="" />
                        <p class="other">暂无可用银行卡</p>
                    </div>
                </div>
            </div>

            <div
                v-if="$util.getConfig().hideFunc"
                :class="'bank-card-add ' + (bankInfo.length > 2 ? 'margin-top-16' : '')"
                v-on:click="$router.push({ name: 'addbank' })"
            >
                <div class="img-text-contain">
                    <img :src="require('../../assets/img/add-bank.svg')" alt="" />
                    <p class="other">新增银行卡</p>
                </div>
            </div>
        </div>
        <div class="bar-contain">
            <div class="bar"></div>
            <div class="bar-text">可选银行</div>
        </div>
        <support-bank></support-bank>
        <el-dialog
            title="银行卡删除"
            :visible.sync="dialogVisible"
            class="prop info-tips"
            width="480px"
        >
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" aria-hidden="true" />
                        <span>
                            此操作将永久删除该银行卡
                            {{ isPwdCheck ? "，输入交易密码进行删除" : "" }}！
                        </span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <!--                        <span-->
                        <!--                            class="redemp-btn"-->
                        <!--                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"-->
                        <!--                        >-->
                        <!--                            <span class="like-a">忘记密码？</span>-->
                        <!--                        </span>-->
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取消</el-button>
                <el-button type="primary" v-on:click="deleteBankCon(deleteId, payCenterId)">
                    删除
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import SupportBank from "@/bizcomponents/bank/supportBankDc.vue";

export default {
    name: "BankDc",
    components: {
        SupportBank
    },
    mixins: [mixin],
    data() {
        return {
            bankInfo: [],
            dialogVisible: false,
            visible: false,
            isPwdCheck: false,
            hkId: "",
            isdellastcard: "",
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            allowchange: "",
            deleteId: "",
            payCenterId: "",
            // 蓝色背景：建设银行、交通银行、民生银行、兴业银行、农业银行、@农村信用社、@浦发银行、@上海银行、@上海农商银行、@深圳银行、@杭州银行、@汉口银行、@中国银联
            colorBlue: "103,105,301,305,309,325,A40,310,325",
            paychannelInfoList: []
        };
    },
    mounted() {
        if (this.$cache.getBinded()) {
            this.getBankInfo();
        }
    },
    methods: {
        // 删除的银行卡
        deleteBank(id, payCenterId) {
            this.deleteId = id;
            this.payCenterId = payCenterId;
            this.dialogVisible = true;
            this.$util.queryValidPwdTrdMethod("0B6", (res) => {
                this.isPwdCheck = res;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            });
        },
        addHK(bank) {
            this.visible = true;
            this.hkId = bank;
            this.$util.queryValidPwdTrdMethod("0A3", (res) => {
                this.isPwdCheck = res;
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
            });
        },
        addHKCon(id) {
            const _this = this;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    const res = await userApi.combBankCardCreate({
                        tradepassword: _pwd,
                        depositcard: this.hkId.depositcard,
                        bankcode: this.hkId.bankcode,
                        certificateno: this.$cache.getUser().certificateno,
                        certificatetype: this.$cache.getUser().certificatetype,
                        paychannel: "0001",
                        bankcardmobile: this.hkId.mobileno,
                        depositname: this.$cache.getUser().custname,
                        bankname: this.$cache.getDict("110080", this.hkId.bankcode),
                        branchinterbankcode: this.hkId.branchinterbankcode
                    });
                    if (res.code == "0") {
                        this.visible = false;
                        this.getBankInfo();
                        this.$message({
                            type: "success",
                            message: "增加汇款卡成功!"
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 删除银行卡
        deleteBankCon(id, payCenterId) {
            const _this = this;
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    _this.dialogVisible = false;
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    const res = await userApi.delBankCard({
                        bankcardid: id,
                        tradepassword: _pwd
                    });
                    if (res.code === "0") {
                        _this.dialogVisible = false;
                        _this.getBankInfo();
                        _this.$message({
                            type: "success",
                            message: "银行卡删除成功!"
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        async getBankInfo() {
            const reqRes = await userApi.getMyBankCards();
            const res = reqRes.data;
            this.bankInfo = [];
            if (res.data) {
                // 同一张卡显示 汇款渠道 和 线上渠道，不再区分两张卡
                let resData = (res.data ? res.data : []).filter((item) => {
                    return (item.channeltype || "") !== "1"; // 0 普通渠道 1 三方渠道
                });
                resData.forEach((item) => {
                    let isPush = true;
                    resData.forEach((item1) => {
                        if (
                            item.bankcode == item1.bankcode &&
                            item.paycenterid == "0001" &&
                            item1.paycenterid != "0001" &&
                            item.desendepositcard == item1.desendepositcard
                        ) {
                            isPush = false;
                        }
                    });
                    if (isPush) {
                        this.bankInfo.push(item);
                    }
                });
                // 屏蔽汇款卡
                // this.bankInfo = this.bankInfo.filter((item) => {
                //     return item.paycenterid !== "0001";
                // });
                this.bankInfo.forEach((bankItem) => {
                    if (
                        bankItem.specialflagofchannel.indexOf("s") > -1 ||
                        bankItem.specialflagofchannel.indexOf("t") > -1
                    ) {
                        bankItem.identifytype = "1";
                    } else if (
                        bankItem.specialflagofchannel.indexOf("r") > -1 ||
                        bankItem.specialflagofchannel.indexOf("u") > -1
                    ) {
                        bankItem.identifytype = "2";
                    } else {
                        bankItem.identifytype = "0";
                    }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
/* 用户持有银行卡信息 */
.bizcomp-hold-bank {
    padding-left: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }
        .prompt-info {
            .el-icon-warning {
                color: $color-a;
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }
            span {
                vertical-align: middle;
            }
        }
    }
    .redemp-btn {
        margin-left: 3%;
    }
    .manage-bank {
        text-align: center;
        font-size: $f18;
        line-height: 30px;
        padding: 20px 0;
        border-top: 1px solid $border-color3;
    }
    .hold-bank-list-contain {
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        margin-top: 16px;
        .bank-card-add {
            width: 370px;
            height: 180px;
            border-radius: 8px;
            background: #ffffff;
            box-sizing: border-box;
            border: 1px solid #d9d9d9;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .img-text-contain {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .no-card {
                width: 36px;
                height: 36px;
                border-radius: 50%;
            }
            .other {
                margin-left: 6px;
                font-size: 16px;
                font-weight: normal;
                color: #e60012;
            }
        }
    }
    .hold-bank-list {
        .bank-card {
            cursor: pointer;
            width: 370px;
            height: 180px;
            box-sizing: border-box;
            border-radius: 8px;
            opacity: 1;
            background: linear-gradient(296deg, #fe5262 1%, #fe7f66 100%);
            .bank-info {
                padding: 16px;
                box-sizing: border-box;
                display: flex;
                .bank-img {
                    width: 50px;
                    height: 50px;
                    padding: 7px;
                    box-sizing: border-box;
                    border-radius: 50%;
                    background: #ffffff;
                    img {
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                    }
                }
                .bank-name {
                    margin-left: 10px;
                    display: inline-block;
                    vertical-align: middle;
                    span {
                        display: block;
                        &.t {
                            height: 24px;
                            font-size: 18px;
                            font-weight: bold;
                            color: #ffffff;
                        }
                        &.c {
                            height: 20px;
                            font-size: 14px;
                            font-weight: normal;
                            color: #ffffff;
                        }
                    }
                }
            }
            .bank-num {
                height: 30px;
                font-size: 22px;
                font-weight: 500;
                text-align: center;
                color: #ffffff;
            }

            .bank-action {
                padding-top: 20px;
                padding-right: 16px;
                text-align: right;
                .bank-btn {
                    width: 70px;
                    height: 32px;
                    line-height: 32px;
                    border-radius: 2px;
                    box-sizing: border-box;
                    border: 1px solid #ffffff;
                    font-size: 14px;
                    font-weight: normal;
                    text-align: center;
                    color: #ffffff;
                    background-color: rgb(254, 86, 98);
                    margin-left: 10px;
                    cursor: pointer;
                }
            }
        }
    }
    .bar-contain {
        display: flex;
        align-items: center;
        margin: 20px 0;
        .bar {
            width: 3.71px;
            height: 16.73px;
            background: #e60012;
        }
        .bar-text {
            margin-left: 6.29px;
            font-family: Source Han Sans CN;
            font-size: 18px;
            font-weight: 500;
            color: #333333;
        }
    }
    .margin-top-16 {
        margin-top: 16px;
    }
    .margin-right-25 {
        margin-right: 25px;
    }
}
</style>
